import React from "react";
import { Droplet, Wrench, Toilet, Waves, Camera, Sparkles } from "lucide-react";

const SERVICES = [
  {
    Icon: Droplet,
    title: "Débouchage canalisation",
    desc: "Intervention rapide sur tous types de canalisations bouchées : éviers, lavabos, baignoires, douches et colonnes communes.",
  },
  {
    Icon: Toilet,
    title: "WC & toilettes bouchés",
    desc: "Débouchage de WC sans démontage de cuvette. Extraction de lingettes, papier et corps étrangers en toute propreté.",
  },
  {
    Icon: Waves,
    title: "Évacuation bouchée",
    desc: "Dégorgement express des évacuations de cuisine, salle de bain et machine à laver. Élimination des graisses incrustées.",
  },
  {
    Icon: Wrench,
    title: "Curage haute pression",
    desc: "Hydrocurage professionnel à 350 bars pour les collecteurs, chutes d'eaux usées et réseaux de copropriété.",
  },
  {
    Icon: Camera,
    title: "Inspection caméra",
    desc: "Diagnostic visuel par caméra endoscopique pour localiser précisément l'origine du bouchon, sans casser.",
  },
  {
    Icon: Sparkles,
    title: "Entretien préventif",
    desc: "Contrats d'entretien annuels pour syndics, bailleurs et professionnels. Tarifs préférentiels et planning sur mesure.",
  },
];

export const Services = () => (
  <section id="services" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
        Nos prestations
      </div>
      <h2
        className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0F172A] mb-4"
        style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
      >
        Tout pour vos canalisations.
      </h2>
      <p className="text-slate-600 text-base md:text-lg max-w-2xl mb-12">
        Six services complets pour résoudre votre problème de plomberie de manière
        durable, propre et garantie.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map(({ Icon, title, desc }, i) => (
          <div
            key={i}
            data-testid={`service-card-${i}`}
            className="group relative bg-white border border-slate-200 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-xl transition-all"
          >
            <div className="w-12 h-12 rounded-xl bg-[#0F172A] text-[#FF5A1F] flex items-center justify-center mb-5 group-hover:bg-[#FF5A1F] group-hover:text-white transition">
              <Icon className="w-6 h-6" strokeWidth={2} />
            </div>
            <h3 className="text-xl font-extrabold text-[#0F172A] mb-2 tracking-tight">
              {title}
            </h3>
            <p className="text-slate-600 leading-relaxed text-sm">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
